import React, { useState } from "react";
import { Accordion, Button, Col, Container, Form, Row } from "react-bootstrap";
// css
import styles from "./TaskList.module.scss";
import { generatePath, Link, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CommonToolTip, CstmPagination, NoRecordFound } from "components/Common/Common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import moment from "moment";
import { convertToMomentDate, errorMessageToast, userFullName } from "helpers/common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useGetStaffGroupTasksListQuery } from "store/services/supportStaff";
import { CLIENT_TYPE_OPTIONS, FUTUTRE_DATE_ERROR_MESSAGE } from "config/constants";
import { MANAGE_STAFF_GROUP_SESSION_VIEW } from "config/paths";
import calendarImage from "Assets/images/calendar_month.svg"
import calendarImageGrey from "Assets/images/calendar_month-grey.svg"


const GroupTasks = () => {

  const { staffId, taskType, groupId } = useParams();
  const clientId = ""
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({ search: "", sort: { column: "id", direction: "desc" } });
  const [showModal, setShowModal] = useState(false)

  // const [completeTask, { isLoading: completeTaskLoading }] = useMarkTaskCompleteMutation();
  const { data, isLoading, isError, isFetching } = useGetStaffGroupTasksListQuery({ staffId, groupId, payload: { page: currentPage, limit: pageSize, ...filter } });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const completeTaskLoading = false

  const column = [
    {
      head: "Last Name",
      accessor: "LastName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className='m-0 fw-sbold text-capitalize'>{item?.lastname || "--"}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "FirstName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className='m-0 fw-sbold text-capitalize'>{item?.firstname || "--"}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "DOB",
      isComponent: true,
      component: (item, ind) => (
        <>{item ? convertToMomentDate(item?.dob) : "--"}</>
      ),
    },
    {
      head: "Grade",
      accessor: "grade",
      component: (item, ind) => (
        <>{item?.grade || "--"}</>
      ),
    },
    // {
    //   head: "Date Created",
    //   accessor: "DOB",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <>{item ? convertToMomentDate(item?.createdAt) : "--"}</>
    //   ),
    // },
    {
      head: "Status",
      accessor: "Confirmed",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <p
          style={{ width: 110 }}
          className={`${item?.status == "pending"
            ? "yellowStatus"
            : "greenStatus"
            } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
        >
          {item?.status}
        </p>
      ),
    },
    // {
    //   head: "Action",
    //   accessor: "Action",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <>
    //       <div className='d-flex'>
    //         <>
    //           {/* <Button
    //             className='commonBtn text-uppercase btn btn-primary'
    //             style={{ minWidth: "120px", height: "33px" }}
    //             onClick={() => {
    //               navigate(generatePath(START_SESSION, { taskId: id, clientId: item?.client_id }), { state: { task_datetime: moment.utc(item?.schedule_date).format("YYYY-MM-DDTHH:mm:ssZ") } });
    //             }}
    //           >
    //             Target Plan
    //           </Button> */}
    //           <StartSessionLink
    //             type='group'
    //             taskId={id}
    //             clientId={item?.client_id}
    //             taskDate={item?.schedule_date}
    //           />
    //         </>
    //       </div>
    //     </>
    //   ),
    // },
  ];

  const resetFilter = () => {
    setFilter({ search: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  // const getClientTypeLabel = (clientTypeValue) => {
  //   const clientType = CLIENT_TYPE_OPTIONS.find(type => type.value === clientTypeValue);
  //   return clientType ? clientType.label : "--";
  // };
  const handleCompleteTask = async () => {
    try {
      setShowModal(false);
      let updateStatus = '';
      if (data?.status === 'completed') {
        updateStatus = 'pending';
      } else {
        updateStatus = 'completed';
      }
      // const result = await completeTask({ task_id: data?.id, owner: data?.owner?.id, updateStatus });
      const result = {}
      if (result?.error) return;

      successMessageToast(result?.data?.message);
      navigate(generatePath(CLIENTS, { activeTab: "Groups" }));

    } catch (err) {
      console.log("Error Completing Task", err);
    };
  };
  return (
    <>
      {/* {isFetching && (
        <div >
          <LoadingOverlay />
        </div>
      )} */}
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        type={"update"}
        confirmHandler={handleCompleteTask}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >{
          isFetching ? (
            <div style={{ height: "200px" }}>
              <LoadingIndicator />
            </div>) :

            <Container fluid>
              <Row>
                <Col
                  lg="12"
                  className=""
                >
                  <Row>
                    <Col lg="12" className="my-3">
                      <div className="my-3">
                        <ul className="list-unstyled mb-0 d-flex align-items-center">
                          <li className="m-0 p-0">
                            <Link
                              className="themeBlue fw-sbold"
                              style={{ textDecoration: "underline" }}
                            // to={MANAGE_STAFF}
                            >
                              Support Staff
                            </Link>
                          </li>
                          <li className="">
                            <h5 className="m-0 fw-bold themeBlue">
                              / Tasks
                            </h5>
                          </li>
                        </ul>
                      </div>
                      <section className='mt-4'>
                        <Container fluid>
                          <h4 className='m-0 fw-bold themeBlue text-capitalize'>{userFullName(data?.clientDetails?.associatedClient)}</h4>
                          <Row className="mb-5 mt-2">
                            <Col lg='6'>
                              <Row>
                                {[
                                  // { label: "Last Name", value: data?.clientDetails?.associatedClient?.lastname },
                                  // { label: "First Name", value: data?.clientDetails?.associatedClient?.firstname },
                                  // { label: "DOB", value: convertToMomentDate(data?.clientDetails?.associatedClient?.client_detail?.dob) },
                                  // // { label: "Name of Discipline", value: data?.tasks?.[0]?.associatedTasks?.owner?.therapist_detail?.therapist_discipline?.name },
                                  // // { label: "Supervisor", value: userFullName(data?.tasks?.[0]?.associatedTasks?.owner) },
                                  { label: "Task Title", value: data?.task_title },
                                  { label: "Group Name", value: data?.group_name },
                                  { label: "Staff Name", value: userFullName(data?.StaffDetails) },
                                  { label: "Therapist", value: userFullName(data?.owner) },
                                ].map((item, index) => (
                                  (["Grade", "School"]?.includes(item?.label) && data?.clientDetails?.associatedClient?.client_detail?.client_type == "private") ? null :
                                    <Col md="6" sm="6" className='my-2' key={index}>
                                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 className="m-0 themeBlue fw-bold">
                                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                          {item.label}
                                        </h6>
                                        <p className="m-0 themeBlue pt-2">{item.value || "--"}</p>
                                      </div>
                                    </Col>
                                ))}
                                {data?.clientDetails?.associatedClient?.client_detail?.client_type == "private" && data?.clientDetails?.associatedClient?.client_detail?.client_guardian_mapping?.map((item, index) => (
                                  (item?.label == "Grade" && data?.clientDetails?.associatedClient?.client_detail?.client_type == "private") ? null :
                                    <Col md="3" sm="6" className='my-2' key={index}>
                                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 className="m-0 themeBlue fw-bold">
                                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                          {`${item?.client_guardian?.client_role?.title} ${index + 1}`}
                                        </h6>
                                        <p className="m-0 themeBlue pt-2">{userFullName(item.client_guardian) || "--"}</p>
                                      </div>
                                    </Col>
                                ))}
                              </Row>
                            </Col>

                            <Col lg='6'>
                              <Row className='justify-content-end pe-2 align-items-start'>
                                <Col lg="4" className='my-2'>
                                  <div className="cardCstm p-3 bg-white shadow h-100 rounded border-bottom">
                                    <h6 class="m-0 themeBlue fw-bold">
                                      <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                        ■</span>{" "}
                                      Start Date
                                    </h6>
                                    <div className='d-flex pt-2 align-items-center'>
                                      <img src={calendarImageGrey} alt="calender_grey_img" />
                                      <p class="m-0 themeBlue ms-1">
                                        {convertToMomentDate(data?.task_datetime)}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                    <h6 class="m-0 themeBlue fw-bold">
                                      <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                        ■</span>{" "}
                                      End Date
                                    </h6>
                                    <div className='d-flex pt-2 align-items-center'>
                                      <img src={calendarImageGrey} alt="calender_grey_img" />
                                      <p class="m-0 themeBlue ms-1">
                                        {convertToMomentDate(data?.ends_on_data?.endDate)}
                                      </p>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg="4" className='my-2 rounded py-3 h-100' style={{ border: "1px solid #41A2A8", backgroundColor: "#97BC740A" }}>
                                  <div className="py-2 mt-1 h-100 rounded d-flex flex-column align-items-center justify-content-center">
                                    <img src={calendarImage} alt="calender_img" />
                                    <h4 className='pt-3' style={{ fontSize: "16px" }}>Task Schedule</h4>
                                    <h5 className='' style={{ fontWeight: "bold", fontSize: "14px" }}>
                                      {data?.duration === 'no_repeat' ? 'No Repeat' : `${data?.custom_duration?.every} / ${data?.custom_duration?.durationType}`}
                                    </h5>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Container>
                      </section>
                    </Col>
                    <Col lg="12">
                      <Row className="align-items-center">
                        <Col lg='10' className='d-flex gap-3'>

                          <section className='mt-4 w-100'>
                            <Container fluid>
                              <div className='px-2 py-3 rounded' style={{ backgroundColor: "#B46C9F1F" }}>
                                <p className='mb-0' style={{ color: "#071E3E" }}><span className='px-2 py-2 rounded me-3' style={{ backgroundColor: "#B46C9F33", color: "#82777f", fontWeight: "700" }}>Cinician's instructions</span>
                                  {data?.description || "--"}
                                </p>
                              </div>

                            </Container>
                          </section>
                        </Col>
                        <Col lg='2' className='mt-4'>
                          <>
                            {/* <StartSessionLink
                                    style={{ height: "35px" }}
                                    type='group'
                                    taskId={id}
                                    taskDate={item?.schedule_date}
                                  /> */}
                          </>
                          {/* {data?.status !== "completed" ? ( */}
                          <p
                            style={{ width: 110 }}
                            className={`${data?.status === "pending" ? "yellowStatus" : "greenStatus"} status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                          >
                            {data?.status}
                          </p>
                          {/* <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowModal(true);
                            }}
                            className={`btn p-0 mb-2 w-100 ${data?.status == "completed" ? "btn-success" : "btn-primary commonBtn"}`}
                            style={{ height: "35px" }}
                          >
                            {completeTaskLoading ? <LoadingIndicator color="white" /> : data?.status !== "completed" ? " Mark Complete" : "Completed"}
                          </Button> */}
                          {/* // ) : (
                          //   <span className='btn btn-success'>Completed</span>
                          // )} */}
                        </Col>
                      </Row>
                    </Col>
                    <section className='mt-4'>
                      <Container fluid className=''>
                        {
                          !data?.taskAssigned?.length ? <NoRecordFound /> : data?.taskAssigned?.map((item, index) => {
                            const scheduleDate = new Date(item?.schedule_date);
                            const currentDate = new Date();
                            const isFutureDate = scheduleDate > currentDate;
                            return (
                              <div key={index} className='p-4 pb-0 rounded' style={{ backgroundColor: "#3DA0AA17" }}>
                                <div className="pb-4 h-100 rounded d-flex align-items-center">
                                  <Col lg='6' className='d-flex align-items-center'>
                                    <h6 class="m-0 themeBlue fw-bold">
                                      <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                        ■</span>{" "}
                                      Date
                                    </h6>

                                    <div className='d-flex ms-2 align-items-center'>
                                      {/* <img src={Images.calender_grey_img} alt="calender_grey_img" /> */}
                                      <p class="m-0 themeBlue ms-1">
                                        {convertToMomentDate(item?.schedule_date)}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg='6' className='d-flex gap-3 justify-content-end'>
                                    <>
                                      {/* <StartSessionLink
                                    style={{ height: "35px" }}
                                    type='group'
                                    taskId={id}
                                    taskDate={item?.schedule_date}
                                  /> */}
                                    </>
                                    {/* {data?.status !== "completed" ? (
                                      <Button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setShowModal(true);
                                        }}
                                        className='commonBtn btn btn-primary p-0 mb-2'
                                        style={{ height: "35px" }}
                                      >
                                        Mark Complete
                                      </Button>
                                    ) : (
                                      <span className='btn btn-success'>Completed</span>
                                    )} */}
                                    <div onClick={() => isFutureDate && errorMessageToast(FUTUTRE_DATE_ERROR_MESSAGE)} >
                                    <Link
                                      target='_blank'
                                      to={{
                                        pathname: generatePath(MANAGE_STAFF_GROUP_SESSION_VIEW, {
                                          // taskType: 'single',
                                          staffId: staffId,
                                          groupId: groupId,
                                          // taskId: item?.assigned_task_id,
                                        }),
                                        search: `?task_datetime=${encodeURIComponent(moment.utc(item?.schedule_date).format("YYYY-MM-DDTHH:mm:ssZ"))}`
                                      }}
                                      className={`btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold`}
                                      // className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "

                                      style={{
                                        height: "35px",
                                        maxWidth: "100px",
                                        pointerEvents: isFutureDate ? 'none' : 'auto', // Disable click if needed
                                        opacity: isFutureDate ? 0.5 : 1,              // Visual cue for disabled
                                      }}
                                    >
                                      Target Plan
                                    </Link>
                                    </div>
                                  </Col>
                                </div>
                                <h5 className='m-0 fw-bold themeBlue text-capitalize'>{data?.task_title || "--"}</h5>

                                <div className='group-details-table'>
                                  <TableLayout column={column} data={item?.members || []} />
                                </div>
                              </div>
                            )
                          })
                        }
                      </Container>
                    </section>
                    {/* <Col lg="12" className="my-3">
                  <div className="mb-4">
                    <SingleTaskAccordion tasks={data?.records} staffId={staffId} taskType={taskType} clientId={clientId} />
                  </div>
                  <CstmPagination
                    totalPages={totalPages}
                    activePage={currentPage}
                    handlePageChange={handlePageChange}
                  />
                </Col> */}
                  </Row>
                </Col>
              </Row>

            </Container >
        }
      </section >
    </>
  );
};

export default GroupTasks;

